/* eslint-disable radix */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useOidc, useOidcIdToken } from '@axa-fr/react-oidc';
import { useNavigate } from 'react-router-dom';
import { Select, IconButton, MenuItem, ListItemIcon, Divider, Menu, Grid } from '@mui/material';
import Logout from '@mui/icons-material/Logout';
import {
  closeIconBlack, homeImage, homeColorImage, veolia_header,
  home_header, home_Icon_hover, language, cipLogo
} from '../../shared/assets/images';
import Notification from '../../shared/notification-modal';
import { defaultModalOptions, defaultUnitValues, test_email, user1_email } from '../../shared/constantVariable';

import cognitoUtils from '../../lib/cognitoUtils';
import Help from '../help/help';
import AboutPopup from '../about';
// import {English, EDI, RO, header, pump, cartridge, CIP,
//   stripper, mixspilt, chemdose, ERD, PW, TC, ProjectInfo, Landing, Notification_Modal, help_modal_form
// } from '../../winflowsText';
// import { removeLocalStorageValue, checkLocalStorageValue } from '../../shared/helper';
// import { defaultUnitValues, defaultModalOptions, executeDefault, defaultSetUnitsetdict } from '../shared/constantVariable';
// import { getWinflowsFileContent_units } from '../../shared/api/url-helper';
// import { decrypt_data } from '../../shared/utils';
import Languages from '../../language';
import { clearLogs } from '../../logger';
import '../../styles/header.scss';
import { set_language_selection } from '../userData';

const CipCalculatorVal = [{ 'str': 'CIP Calculator', 'key': 'CIPCalculator' }];

const HeaderSection = () => {
  const { i18n, t } = useTranslation();
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout, isAuthenticated } = useOidc();
  const { idTokenPayload } = useOidcIdToken();
  const [expTime, setexpTime] = useState({});
  const [userDetails, setUserDetails] = useState('');
  const [userMail, setUserMail] = useState('');
  const [visibleAbout, setVisibleAbout] = useState(false);
  const [isHoveredDashboard, setIsHoveredDashboard] = useState(false);
  const [, setImageChange] = useState(homeImage);
  const open = Boolean(anchorEl);
  const [isInternal, setInternal] = useState(false);
  const navigate = useNavigate();
  const translateObject = t;
  const handleConfirm = (isSignIN) => {
    setModalOption(defaultModalOptions);
    if (isSignIN) {
      clearLogs();
      cognitoUtils.signOutCognitoSession();
      window.localStorage.clear();
      window.location.href = '/sign-in';
    }
  };

  const handleSessionExpiration = () => {
    // Clear session data from localStorage
    window.localStorage.clear();
    clearLogs();
    // Redirect to login or show a session expired message
    // For example, using a navigation function or setting a state
    window.location.href = '/sign-in'; // Replace with your actual navigation logic
  };

  const handlePopup = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: 'Session has expired. please login!',
      yesOrNo: false,
      onNo: () => handleConfirm(true),
      closeText: 'Sign In',
    });
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      type
    });
  };

  useEffect(() => {
    if (localStorage.getItem('i18nextLng')) {
      const lan = localStorage.getItem('i18nextLng').split('-');
      set_language_selection(lan[0]);
    }
  }, [localStorage.getItem('i18nextLng')]);
  useEffect(async () => {
    const LoginUser = JSON.parse(localStorage.getItem('LoginUser'));
    if (idTokenPayload && isAuthenticated) {
      let mail_id = idTokenPayload.sub;
      if (mail_id === test_email && (process.env.REACT_APP_ENV === 'dev')) {
        mail_id = user1_email;
      }
      setUserMail(mail_id);
      setInternal(mail_id.split('@')[1] === 'veolia.com');
      const userName = mail_id.split('@')[0].toUpperCase().replace(/\./g, ' ');
      setexpTime(idTokenPayload.exp);
      sessionStorage.setItem('expTime', idTokenPayload.exp);
      sessionStorage.setItem('user_email', mail_id);
      sessionStorage.setItem('user_name', userName);
      setUserDetails(userName);

      let currTime = new Date().getTime().toString();
      currTime = currTime.substring(0, 10);
      setTimeout(() => handlePopup(), (parseInt(idTokenPayload.exp) - parseInt(currTime)) * 1000);

      const location = window.location.href;
      if (location.indexOf('/recent-files-list') >= 0) {
        setImageChange(homeColorImage);
      }
    } else if (LoginUser && LoginUser.isAuthenticated) {
      const mail_id = LoginUser.email;
      setUserMail(mail_id);
      setInternal(mail_id.split('@')[1] === 'veolia.com');
      const userName = mail_id.split('@')[0].toUpperCase().replace(/\./g, ' ');
      setexpTime(sessionStorage.getItem('expTime'));
      sessionStorage.setItem('user_email', mail_id);
      sessionStorage.setItem('user_name', userName);
      setUserDetails(userName);

      const currentTime = new Date().getTime();
      if (currentTime > parseInt(expTime)) {
        // Handle session expiration, e.g., redirect to login or show a popup
        handleSessionExpiration();
      }
      const location = window.location.href;
      if (location.indexOf('/recent-files-list') >= 0) {
        setImageChange(homeColorImage);
      }
    } else if (window.location.pathname !== '/sign-in') {
      clearLogs();
      navigate('/sign-in');
    }

  }, [idTokenPayload, isAuthenticated, navigate]);
  // removed units code from here @ kranthi

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
    Cookies.set('language_selection', event.target.value, { expires: 7 });
    set_language_selection(event.target.value || 'en');
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const cropUserName = (text) => {
    if (!text) {
      return 'U';
    };
    const intials = text
      .split(' ')
      .map((arr) => arr[0])
      .join('')
      .toUpperCase();
    return intials;
  };

  const handleLogout = () => {
    localStorage.clear();
    clearLogs(); // remove the files change logs
    if (isAuthenticated) {
      logout();
    } else {
      navigate('/sign-in');
    }
  };

  const closeAboutPopup = () => {
    setVisibleAbout(false);
  };
  // Function to extract the primary language code
  const getPrimaryLanguageCode = (language) => {
    return language.split('-')[0];
  };
  const changeCalculator = (eve) => {
    navigate(`/${eve.target.value}`);
  };
  const getLayout = () => {
    return (
      <div className='navbar-menu'>
        <div className='background-brand d-none' style={{ height: '3px' }} />
        <div className='h-100 nav-container background-brand' style={{ height: '56px' }}>
          <div className='h-100'>
            <Grid container className='h-100 header-container' >
              <Grid className='h-100  header-image' item xs={8} sm={6}>
                <img className='h-100' align="left" src={veolia_header} alt="veolia"
                  style={{ marginLeft: '48px', height: '40px', marginTop: '5px', marginBottom: '5px' }} />
              </Grid>
              <Grid item xs={4} sm={6} className="h-100 recent-file-links sansW4SeLig">
                <ul id="navbar" style={{ marginRight: '48px' }}>
                  <li>
                    <span className="top-navbar" style={{ marginRight: '32px' }} onClick={() => navigate('/recent-files-list')}>
                      <img style={{ marginTop: '-4px' }} src={isHoveredDashboard ? home_Icon_hover : home_header} alt="home"
                        onMouseEnter={() => setIsHoveredDashboard(true)}
                        onMouseLeave={() => setIsHoveredDashboard(false)}
                      />
                    </span>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center' }}>
                    <img className="top-navbar" src={language} />
                    <Select
                      className='language L_Regular' style={{ marginRight: 10, color: '#FCFCFC' }} onChange={changeLanguage}
                      value={getPrimaryLanguageCode(i18n.language)} >
                      {Languages.map(lang => (
                        <MenuItem key={lang.code} value={lang.code}>{lang.name}</MenuItem>
                      ))}
                    </Select>
                  </li>
                  {isInternal && <li style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <img className="top-navbar" src={cipLogo} style={{ width: 27 }} />
                    <span style={{ color: '#fcfcfc', pointerEvents: 'none', position: 'absolute', left: 30 }}>{t('Calculator')}</span>
                    <Select
                      className='language L_Regular' style={{ marginRight: 10, color: '#FCFCFC', width: 110 }} onChange={(event) => { changeCalculator(event); }}
                    >
                      {CipCalculatorVal.map(cal => (
                        <MenuItem key={cal.key} value={cal.key}>{t(cal.str)}</MenuItem>
                      ))}
                    </Select>
                  </li>}
                  <li className='menu-help-wrapper L_Regular' style={{ marginRight: '32px' }}>
                    <Help translateObject={translateObject} />
                  </li>
                  <li>
                    <div className="user-img float-r sansW4SeLig">
                      <IconButton style={{ border: 'none' }} onClick={handleClick} sx={{ p: 0 }}>
                        <span className="sansW4SeLig">
                          {cropUserName(userDetails)}
                        </span>
                      </IconButton>
                    </div>
                  </li>
                </ul>
              </Grid>
              <Menu
                className="header-mui-popup sansW4SeLig"
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <div className="user-account-menu">
                  <MenuItem className="user-image-list">
                    <div className="user-account-img">
                      {/* <Avatar /> */}
                      <IconButton sx={{ p: 0 }}>
                        <span className="sansW4SeLig">
                          {cropUserName(userDetails)}
                        </span>
                      </IconButton>
                    </div>
                  </MenuItem>
                  <MenuItem className="d-flex j-center sansW4SeLig">
                    {userDetails}
                  </MenuItem>
                  <MenuItem className="d-flex j-center sansW4SeLig">
                    {userMail}
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogout} className="sansW4SeLig">
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    {translateObject('Logout')}
                  </MenuItem>
                </div>
              </Menu>
            </Grid>
          </div>
        </div>
        <div className='about-us' id='about-us'>
          <div className='about-us-header' onClick={closeAboutPopup}>
            <img src={closeIconBlack} alt='close' />
          </div>
          <ul>
            <li> <span>DB Version: </span> <span>4.0</span> </li>
            <li> <span>Date: </span> <span>24/02/2023</span> </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <Notification
        options={modalOption}
        views={modalOption}
        handleClose={() => handleConfirm()}
      />
      {getLayout()}
      {visibleAbout && (
        <AboutPopup
          visibleAbout={visibleAbout}
          closeAboutPopup={closeAboutPopup}
          translateObject={translateObject}
        />
      )}
    </>
  );
};
export default HeaderSection;
